export const state = {
  memberInfo: null
}



// WEBPACK FOOTER //
// ./src/store/member/state.js